const FilterType = {
  STRING: "STRING",
  NUMBER: "NUMBER",
  DATE: "DATE",
  BOOLEAN: "BOOLEAN",
  BRANCHTYPE: "BRANCHTYPE",
  PROJECTTYPE: "PROJECTTYPE",
  FRAMEWORKSTATUS: "FRAMEWORKSTATUS",
  APPROVALSTATUS: "APPROVALSTATUS",
  LOV: "LOV"
};

module.exports = Object.freeze({
  FilterType
});
